import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {
  SkyDatepickerCalendarInnerComponent
} from './datepicker-calendar-inner.component';
import {
  SkyDatepickerConfigService
} from './datepicker-config.service';

import {
  SkyDateFormatter
} from './date-formatter';


export class SkyDatepickerCalendarComponent {

  
  public minDate: Date;

  
  public maxDate: Date;

  /** starting day of the week from 0-6 (0=Sunday, ..., 6=Saturday) */
  
  public startingDay: number;

  /** currently selected date */
  
  public selectedDate: Date;

  
  public selectedDateChange: EventEmitter<Date> = new EventEmitter<Date>(undefined);

  
  public calendarModeChange: EventEmitter<string> = new EventEmitter<string>();

  
  public _datepicker: SkyDatepickerCalendarInnerComponent;

  protected _now: Date = new Date();
  protected config: SkyDatepickerConfigService;

  private formatter = new SkyDateFormatter();

  public constructor(config: SkyDatepickerConfigService) {
    this.config = config;
    this.configureOptions();
  }

  public configureOptions(): void {
    Object.assign(this, this.config);
  }

  public onCalendarModeChange(event: string): void {
    this.calendarModeChange.emit(event);
  }

  public onSelectedDateChange(event: Date): void {
    this.selectedDateChange.emit(event);
  }

  public writeValue(value: Date): void {
    if (value !== undefined
      && this.formatter.dateIsValid(value)
      && this.selectedDate !== undefined
      && this._datepicker.compareHandlerDay(value, this.selectedDate) === 0) {
      return;
    }

    if (this.formatter.dateIsValid(value)) {
      this.selectedDate = value;
      this._datepicker.select(value, false);
    } else {
      this.selectedDate = new Date();
      this._datepicker.select(new Date(), false);
    }

  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-datepicker-calendar',
  template: `<div class="sky-datepicker-calendar">
  <sky-datepicker-inner
      [selectedDate]="selectedDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [startingDay]="startingDay"
      (selectedDateChange)="onSelectedDateChange($event)"
      (calendarModeChange)="onCalendarModeChange($event)">
    <sky-daypicker tabindex="0"></sky-daypicker>
    <sky-monthpicker tabindex="0"></sky-monthpicker>
    <sky-yearpicker tabindex="0"></sky-yearpicker>
  </sky-datepicker-inner>
</div>
`,
  styles: [`.sky-datepicker-calendar {
  display: block;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyDatepickerConfigService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'minDate': [{ type: Input },],
'maxDate': [{ type: Input },],
'startingDay': [{ type: Input },],
'selectedDate': [{ type: Input },],
'selectedDateChange': [{ type: Output },],
'calendarModeChange': [{ type: Output },],
'_datepicker': [{ type: ViewChild, args: [SkyDatepickerCalendarInnerComponent, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
